<template>
  <div class="donors-actions">
    <div class="action-wrapper">
      <a href="https://donate.innoafrica.org/" target="_blank"
        >Donate any amount</a
      >
    </div>
    <div class="action-wrapper">
      <button @click="toggleAdoptVillagePopup">Adopt the entire village</button>
    </div>
  </div>
  <div v-if="adoptVillagePopup" class="popup">
    <span class="close-btn" @click="handlePopupClose">X</span>
    <h3 style="font-size: 22px; margin-bottom: 20px; max-width: 400px">
      Thank you for wanting to adopt this village for ${{
        cost.toLocaleString('en-US')
      }}
      and change their lives forever. 100% of your donation will go directly to
      this village.
    </h3>

    <div v-if="!messageSent" style="width: 100%">
      <div class="donors-actions-popup">
        <span v-if="popupAlertName" style="font-size: 13px"
          ><span class="text-red-500">*</span> Please enter a valid name.</span
        >
        <input v-model="contactUsObject.name" type="text" placeholder="Name" />
        <span v-if="popupAlertEmail" style="font-size: 13px"
          ><span class="text-red-500">*</span> Please enter a valid email
          address.</span
        >
        <input
          v-model="contactUsObject.email"
          type="email"
          placeholder="Email"
        />
        <textarea
          v-model="contactUsObject.message"
          placeholder="Message"
          style="min-height: 50px"
        ></textarea>
      </div>
      <div style="max-width: 400px; margin-top: 20px">
        <button class="donors-actions-popup-btn" @click="send">Send</button>
      </div>
    </div>
    <div v-else style="width: 100%">
      <el-alert
        title="Thank you, we will contact you soon."
        type="success"
        show-icon
        :closable="false"
      />
    </div>
  </div>
  <div
    v-if="adoptVillagePopup"
    class="popup-open"
    @click="handlePopupClose"
  ></div>
</template>

<script>
import axios from 'axios'
export default {
  props: {
    cost: Number,
    projectId: Number,
  },
  data() {
    return {
      adoptVillagePopup: false,
      popupAlertEmail: false,
      popupAlertName: false,
      messageSent: false,
      sendRunning: false,
      contactUsObject: {
        name: '',
        email: '',
        message: '',
      },
    }
  },
  methods: {
    toggleAdoptVillagePopup() {
      this.adoptVillagePopup = !this.adoptVillagePopup
    },
    handlePopupClose() {
      this.adoptVillagePopup = false
      this.sendRunning = false
      this.popupAlertEmail = false
      this.popupAlertName = false
      this.messageSent = false
      this.contactUsObject = {
        name: '',
        email: '',
        message: '',
      }
    },
    async send() {
      this.sendRunning = true
      this.popupAlertEmail = false
      this.popupAlertName = false
      if (
        !this.isValidEmail(this.contactUsObject.email) ||
        !this.contactUsObject.name
      ) {
        if (!this.isValidEmail(this.contactUsObject.email)) {
          this.popupAlertEmail = true
        }
        if (!this.contactUsObject.name) {
          this.popupAlertName = true
        }
        return
      }

      let params = {
        ...this.contactUsObject,
        project_id: this.projectId,
      }

      try {
        let req = await axios.post('/api/donor_leads', params)
        this.messageSent = true
      } catch (e) {
        console.log(e)
      }
      this.sendRunning = false
    },
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s`@]+$/
      return emailRegex.test(email)
    },
  },
}
</script>

<style lang="scss" scoped>
.donors-actions {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0.5rem;
  @media (max-width: 700px) {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .action-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: space-between;
    p {
      margin-bottom: 0;
    }

    button,
    a {
      width: 80%;
      background: white;
      border: 1px solid #707070;
      border-radius: 10px;
      padding: 12p;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      padding: 12px;
      @media (max-width: 700px) {
        width: 100%;
      }

      &:hover {
        background: #5b5b5b;
        cursor: pointer;
        color: white;
      }
    }
  }
}

.popup-open {
  width: 100%;
  height: 100%;
  z-index: 90;
  background-color: #000000a3;
  left: 0;
  overflow-y: auto;
  position: fixed;
  top: 0;
}

.popup {
  position: absolute;
  top: 26%;
  align-self: center;
  width: fit-content;
  height: fit-content;
  background: #f0f0f0;
  color: #000000;
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 3rem;
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3),
    0 1px 3px 1px rgba(60, 64, 67, 0.15);
  transition: box-shadow 0.08s linear,
    min-width 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 100;
  max-width: 90%;

  @media (max-width: 600px) {
    width: 90%;
  }

  .popup-btns {
    margin-top: 8px;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #091e4214;
  }
  &::-webkit-scrollbar-thumb {
    background: #091e4214;
  }
  &::-webkit-scrollbar-track {
    background: #091e4214;
    border-radius: 10px;
  }

  .close-btn {
    position: absolute;
    top: 5px;
    right: 10px;
    cursor: pointer;
  }
}

.donors-actions-popup {
  display: flex;
  flex-direction: column;
  max-width: 400px;
  width: 100%;
  gap: 12px;

  input[type='text'],
  input[type='email'],
  textarea {
    width: 100%;
    background: white;
    border: 1px solid #707070;
    border-radius: 10px;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    @media (max-width: 700px) {
      width: 100%;
    }

    &:focus {
      // outline: none;
      box-shadow: none;
    }
  }
}

.donors-actions-popup-btn {
  background: #2c2b2b;
  color: white;
  border-radius: 5px;
  width: 200px;
  padding: 12px;
  transition: background 0.3s ease;

  @media (max-width: 400px) {
    width: 100%;
  }

  &:hover {
    background: #555;
    cursor: pointer;
  }
}
</style>
